export default __webpack_public_path__ + "static/media/Avatar-4-noback.94448768.png";